import React from 'react';
import { Tag } from 'antd';
import { getTagStyles } from '../utils/colorUtils';

/**
 * Компонент тега с автоматическим определением контрастного цвета текста
 * @param {string} backgroundColor - hex цвет фона (например, '#ffffff', '#ffff00')
 * @param {string} children - содержимое тега
 * @param {object} style - дополнительные стили
 * @param {object} props - остальные пропсы для Tag
 */
const ContrastTag = ({ backgroundColor, children, style = {}, ...props }) => {
  // Получаем стили с учетом контрастности
  const contrastStyles = getTagStyles(backgroundColor);
  
  // Объединяем стили
  const finalStyles = {
    ...contrastStyles,
    ...style,
    fontSize: '10px',
    margin: '1px',
    fontWeight: '500'
  };

  return (
    <Tag
      {...props}
      style={finalStyles}
    >
      {children}
    </Tag>
  );
};

export default ContrastTag;
